import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getRefundPolicy = createAsyncThunk(
  "refundPolicy/getRefundPolicy",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axiosInstance.get(
        `/settings/refund_policy?page=${page}&size=${size}&query=${query}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createRefundPolicy = createAsyncThunk(
  "refundPolicy/createRefundPolicy",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/settings/refund_policy`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteRefundPolicy = createAsyncThunk(
  "refundPolicy/deleteRefundPolicy",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(
        `/settings/refund_policy/${args._id}`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
)

const refundPolicySlice = createSlice({
  name: "refundPolicy",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getRefundPolicy.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getRefundPolicy.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.data;
        state.itemsCount = payload.data?.itemsCount;
        state.pages = payload.data?.pages;
        state.error = null;
      })
      .addCase(getRefundPolicy.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createRefundPolicy.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createRefundPolicy.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.itemsCount++;
        state.data.push(payload.data);
        state.error = null;
      })
      .addCase(createRefundPolicy.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteRefundPolicy.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteRefundPolicy.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteRefundPolicy.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default refundPolicySlice.reducer;